import React from "react";
import { AuditLogType } from "../enum";
export const OrderProcessLogViewer = ({ item }) => {
  if (!item) {
    return null;
  }

  function formatDiffAsText(diffObj) {
    const lines = [];
    if(!diffObj) return ''
    Object.entries(diffObj).forEach(([key, value]) => {
      const oldVal = value?.old ?? "-";
      const newVal = value?.new ?? "-";

      const isChanged = JSON.stringify(oldVal) !== JSON.stringify(newVal);
      if (!isChanged) return;

      const format = (val) =>
        typeof val === "object" ? JSON.stringify(val, null, 2) : String(val);

      lines.push(`${key}: ${format(oldVal)} -> ${format(newVal)}`);
    });

    return lines.join("\n");
  }

  return (
    <div>
      <h5>Process Log Snapshot</h5>
      <p><strong>Process ID:</strong> {item.linked_object_id}</p>
      <p><strong>Action:</strong> {item.action}</p>
      <p><strong>Message:</strong> {item.message}</p>

      <div style={{ marginTop: "20px" }}>
        <h6>Details</h6>
        <hr />
        <div style={{ marginTop: "10px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ border: "1px solid #ddd", padding: "8px" }}>Message</th>
                <th style={{ border: "1px solid #ddd", padding: "8px" }}>Value</th>
              </tr>
            </thead>
            <tbody>
              {item.logs.map((log, index) => {
                const changes = log.type === AuditLogType.Info ? formatDiffAsText(log.data) : null;
                return (
                  <tr key={index}>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {log.message}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      <code style={{ whiteSpace: "pre-wrap" }}>
                        {changes ? changes : JSON.stringify(log.data)}
                      </code>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OrderProcessLogViewer;
